'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.omitby');

var _lodash2 = _interopRequireDefault(_lodash);

var _inlineStylePrefixer = require('inline-style-prefixer');

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixer = new _inlineStylePrefixer2.default();

exports.default = function (_ref) {
  var delay = _ref.delay;
  var duration = _ref.duration;
  var fillMode = _ref.fillMode;
  var iterationCount = _ref.iterationCount;
  var name = _ref.name;
  var timingFunction = _ref.timingFunction;

  if (name) {
    /* eslint-disable no-param-reassign */

    /*
    *  don't apply defaults unless we have a name declaration
    *  otherwise, assume we're using this to override properties
    */

    duration = duration || '1.2s';
    iterationCount = iterationCount || 'infinite';
    timingFunction = timingFunction || 'ease-in-out';

    /* eslint-enable no-param-reassign */
  }

  return prefixer.prefix((0, _lodash2.default)({
    animationDelay: delay,
    animationDuration: duration,
    animationFillMode: fillMode,
    animationIterationCount: iterationCount,
    animationTimingFunction: timingFunction,
    animationName: name
  }, function (val) {
    return !val;
  }));
};


//////////////////
// WEBPACK FOOTER
// ./~/better-react-spinkit/dist/util/animate.js
// module id = 414
// module chunks = 0